enum ForwardRequestTabsEnum {
  ReadyShipmentsTab = 1,
  InReviewShipmentsTab = 2,
  AllShipmentsTab = 3,
}

export default ForwardRequestTabsEnum
